<template>
  <div class="app-image-upload" style="position: relative;">
    <div v-if="disabled" class="transparent-bg"></div>
    <div>
      <el-upload
        class="avatar-uploader"
        :style="sliderStyle"
        :headers="headers"
        :action="actionApi"
        :show-file-list="false"
        :http-request="imgRequest"
        :on-change="selectFileUpload">
          <div v-if="imageUrl" style="width: 100%; height: 100%">
            <video v-if="currentFileType == 'video'" controls="controls" :src="imageUrl"></video>
            <img v-if="currentFileType == 'image'" :src="imageUrl" class="avatar">
          </div>
          <i v-if="!imageUrl" class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <!-- 添加删除按钮 -->
      <i v-if="isShowDel && imageUrl" class="el-icon-delete"
        :style="`
          position: absolute;
          top: 1px;
          left: ${Number(sliderStyle.width.replace('px', '')) - 33}px;
          line-height: normal;
          font-size: 20px;
          cursor: pointer;
          display: block;
          background: #000;
          opacity: 0.6;
          color: #fff;
          border-radius: 0 3px 0 50%;
          width: 32px;
          height: 32px;
          line-height: 32px;
          text-align: center;
        `" @click="imageUrl = ''"></i>
    </div>
  </div>
</template>


<script>
  import axios from 'axios'
  import Vue from "vue";
  import Swal from "sweetalert2";
export default {
  components: {},
  props: {
    type: {
      type: String,
      default: 'image',
    },
    disabled: {
      type: Boolean,
      default: false
    },
    size:{
      type: String,
      default: '1:1',
    },
    isShowDel: {
      type: Boolean,
      default: false,
    },
    maxSize: {
      type: Number,
      default: 0,
    },
    fixedWidth: {
      type: Number,
      default: 0,
    }
  },
  watch: {
    // 监听 图片地址
    imageUrl: {
        handler(val) {
            this.$emit('uploadChange', val)
        },
        deep: true
    }
},
  data() {
    return {
      headers: {},
      actionApi: env.API_HOST + '/create-platform/upload',
      imageUrl: '',
      currentFileType: '',
      scale: {},
      sliderStyle: {}
    };
  },

  
  mounted() {
    this.headers = { "x-auth-token": this.cookies.getCookie('token') }
    // 根据图片所需比例显示图片
    let wh = this.size.split(":"); //字符分割
    let fixedHeight = 0
    if(wh[1] > 15){
      fixedHeight = 400 //固定高度400px
    } else {
      fixedHeight = 200 //固定高度200px
    }
    let fixedWidth = Math.ceil(wh[0]/wh[1] * fixedHeight)

    if (this.fixedWidth > 0) {
      fixedWidth = this.fixedWidth
      fixedHeight = Math.ceil(wh[1]/wh[0] * fixedWidth)
    }

    this.sliderStyle = {
      background: '#fff',
      width: fixedWidth + 'px',
      height: fixedHeight + 'px'
    }
  },

  methods: {
    handleAvatarSuccess(res, file) {
      this.imageUrl = res.data
    },

    setImageUrl(image){
      this.imageUrl = image
      this.currentFileType = 'image'
      var lastIndex = image.lastIndexOf(".");
      if(lastIndex){
        var fileType = image.substr(lastIndex + 1);
        if(fileType){
          if(fileType === "mp4"){
            this.currentFileType = 'video'
          }
        }
      }
    },

    imgRequest(){
      return false
    },

    getImageUrl(){
      return this.imageUrl
    },

    selectFileUpload(file){
      console.log('上传的文件', file)
      if(this.type === 'image'){
        const isImage =
        file.raw.type === "image/jpeg" ||
        file.raw.type === "image/png" ||
        file.raw.type === "image/jpg" ||
        file.raw.type === "image/webp" ||
        file.raw.type === "image/gif";
        if (!isImage) {
          Vue.swal("只支持上传图片格式");
          return
        }
        this.currentFileType = 'image'
      }
      if (this.maxSize > 0) {
        const fileSize = file.size / 1024 / 1024
        if (fileSize > this.maxSize) {
          return Vue.swal(`图片大小超出 ${this.maxSize}M`);
        }
      }
      if(this.type === 'video'){
        if(file.raw.type != "video/mp4"){
          Vue.swal("只支持上传mp4视频文件");
          return
        }
        this.currentFileType = 'video'
      }
      this.fileUpload(file.raw)
    },
    fileUpload(file){
      this.imageUrl = ''
      let formData = new FormData();
      formData.append('file', file);
      let that = this
      axios({
        headers: this.headers,
        url: this.actionApi,
        method: 'post',
        data: formData,
      }).then(resp => {
        if (resp.code == 0) {
          this.imageUrl = resp.data
        } else {
          Vue.swal(resp.msg);
        }
      }).catch(err => {
        console.log(err);
      });
    },

  }

}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

  .app-image-upload .avatar-uploader .el-upload {
    border: 1px solid #ced4da;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    display: block;
    width: 100%;
    height: 100%;
  }

  .app-image-upload .avatar-uploader .el-upload img{
    width: 100%;
    height: 100%;
  }

  .app-image-upload .avatar-uploader .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .transparent-bg{
    position: absolute;
    background-color: transparent;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 999
  } 

</style>